import { Button } from '@Sage/hoi-poi-ui';
import { getLiteral } from 'utils/getLiteral';
import { publish } from 'lib/EventBuser';
import { OPEN_CREATE_DOMAIN_MODAL } from './constants';

function DomainSettingsHeader() {
    return (
        <div className="marketing-settings__header">
            <Button onClick={() => publish(OPEN_CREATE_DOMAIN_MODAL)}>
                {getLiteral('action_marketing_campaigns_add_domain')}
            </Button>
        </div>
    );
}

DomainSettingsHeader.displayName = 'DomainSettingsHeader';

export default DomainSettingsHeader;
